import React, { useMemo } from 'react'
import { Alert } from 'antd'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

import { loadedInitSelector, marketplaceConnectsSelector } from 'app-redux/selectors'
import useMemoizeCheckPermission from 'utils/hooks/useMemoizeCheckPermission'
import { useMarketplaceConnects } from 'utils/queries'

const MarketplaceConnectionAlert = () => {
  const { formatMessage } = useIntl()
  const loadedInit = useSelector(loadedInitSelector)
  const marketplaceConnects = useSelector(marketplaceConnectsSelector)
  const hasMarketplaceConnect = useMemoizeCheckPermission({ permission: 'marketplace_connect' })

  const { data } = useMarketplaceConnects({
    params: {},
    options: { enabled: loadedInit && hasMarketplaceConnect && marketplaceConnects.length > 0 },
  })

  // Kalau lebih dari satu toko terputus, nama toko dirangkai dalam satu banner supaya kalimat yang
  // isinya identik tidak berulang dan konten halaman tidak kedorong jauh ke bawah.
  const disconnectedShopNames = useMemo(
    () =>
      (data?.marketplace_connect?.data || [])
        .filter((store) => store.status !== 1)
        .map((store) => store.shop_name)
        .join(', '),
    [data],
  )

  if (!disconnectedShopNames) {
    return null
  }

  return (
    <Alert
      type="error"
      showIcon
      closable
      message={formatMessage(
        { id: 'marketplaceConnect.status_error_message' },
        { shopName: disconnectedShopNames },
      )}
    />
  )
}

export default MarketplaceConnectionAlert
